export type { VariantProps } from "class-variance-authority";
export { cva } from "class-variance-authority";
